import './Skeleton.css'

/**
 * Base skeleton component with shimmer animation.
 * Use this as a building block for more complex skeleton layouts.
 *
 * @param {string} variant - 'text' | 'rectangular' | 'circular'
 * @param {string} width - CSS width value (e.g., '100px', '50%')
 * @param {string} height - CSS height value
 * @param {string} className - Additional CSS classes
 * @param {object} style - Inline styles
 */
function Skeleton({
  variant = 'text',
  width,
  height,
  className = '',
  style = {}
}) {
  const baseClass = 'skeleton'
  const variantClass = `skeleton--${variant}`

  return (
    <div
      className={`${baseClass} ${variantClass} ${className}`}
      style={{ width, height, ...style }}
      aria-hidden="true"
    />
  )
}

export default Skeleton
